import { UploadIcon, XIcon } from '@assets/icons';
import { IconButton, TableView } from '@components/button';
import { Group } from '@components/layout';
import { ProgressBar } from '@components/progress';
import { Typography } from '@components/typography';
import { Box, Divider, Stack, useTheme } from '@mui/material';
import { useObservableState } from 'observable-hooks';
import { useUploadModal } from './VolumeUploadProvider';

export const UploadProgressModal = ({ tableView }: { tableView: TableView }) => {
  const { palette } = useTheme();
  const { uploadPercentages$, fileNames$, open$ } = useUploadModal();
  const percentages = useObservableState(uploadPercentages$);
  const names = useObservableState(fileNames$);
  const open = useObservableState(open$);

  const handleClose = () => {
    open$.next(false);
  };

  if (!open) return null;

  return (
    <Stack
      sx={{
        backgroundColor:
          tableView === 'grid' ? palette.background.paper : palette.background.default,
        width: '500px',
        maxHeight: '45vh',
        visibility: open ? 'visible' : 'hidden',
        zIndex: 1000,
      }}
    >
      <Group
        justifyContent="space-between"
        alignItems="center"
        sx={{
          pl: 3,
          pr: 1,
          py: 2,
          borderTopLeftRadius: '2px',
          borderTopRightRadius: '2px',
          opacity: 0.8,
        }}
      >
        <Group gap={2}>
          <UploadIcon color={palette.text.paper} />
          <Typography color={palette.text.paper}>Uploading</Typography>
        </Group>
        <IconButton onClick={handleClose} Icon={XIcon} size={16} />
      </Group>
      <Divider />
      <Box sx={{ overflowY: 'auto' }}>
        {names.map((name) => (
          <Group
            padding={4}
            height="100%"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            key={name}
          >
            <Typography variant="body2" flex={2} handleOverFlow>
              {name}
            </Typography>
            <Stack sx={{ minWidth: '75px' }}>
              <ProgressBar percent={percentages[name]} />
              <Typography variant="caption2" sx={{ textAlign: 'center' }}>
                {percentages[name] === 100 ? 'Completed' : 'In progress'}
              </Typography>
            </Stack>
          </Group>
        ))}
      </Box>
    </Stack>
  );
};
